export default __webpack_public_path__ + "static/967-5711e4fddd94bf249903e762a62b2589.gif";